import { render, staticRenderFns } from "./PayBarCode.vue?vue&type=template&id=7906c0c1"
import script from "./PayBarCode.vue?vue&type=script&lang=js"
export * from "./PayBarCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7906c0c1')) {
      api.createRecord('7906c0c1', component.options)
    } else {
      api.reload('7906c0c1', component.options)
    }
    module.hot.accept("./PayBarCode.vue?vue&type=template&id=7906c0c1", function () {
      api.rerender('7906c0c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/terminal/PayBarCode.vue"
export default component.exports